module.exports = __webpack_public_path__ + "static/media/mobile_g_guide.eef5c7b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile_g_guide.png
// module id = 109
// module chunks = 0